// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Poppins loads via public/index.html's <link>; body covers portaled content too. */
body {
  font-family: Poppins, system-ui, sans-serif;
  font-size: 13px;
  color: #1c1c28;
}

/* gs-integration-component's delete icon 403s from ImageKit; swap for a hosted copy. */
img[alt="delete"] {
  content: url("https://gs-upload.gupshup.io/journey-builder/assets/icon/common/cross.svg");
  width: 14px;
  height: 14px;
  cursor: pointer;
}

/* Global border-box reset compensates for the Tabs panel's own overflow bug. */
*, *::before, *::after {
  box-sizing: border-box;
}

/* overflow-x:clip (not hidden) + overflow-y:visible — hidden on either axis forces the
   other to compute as auto per spec, which breaks position:sticky elsewhere (the template
   preview panel). clip avoids that while still clipping horizontal overflow like hidden did. */
.bloomreach-widget [class*="tabsPanel"] {
  box-sizing: border-box !important;
  max-width: 100% !important;
  overflow-x: clip;
  overflow-y: visible;
}

.bloomreach-widget .nic-tm-header-container,
.bloomreach-widget .nic-tm-footer-container,
.bloomreach-widget .nic-sh-main-container,
.bloomreach-widget .nic-tm-template-search-field {
  max-width: 100%;
}

.bloomreach-widget .nic-tm-header-item {
  min-width: 0;
}

/* Alignment-pass tokens; overrides.css reads the same names. */
.bloomreach-widget {
  --br-column: 1040px;
  --br-text: #1c1c28;
  --br-muted: #6b7186;
  --br-muted-2: #7a8092;
  --br-faint: #8a90a0;
  --br-body: #4c5163;
  --br-control-border: #d7d9e0;
  --br-card-border: #e6e7ec;
  --br-rule: #eeeef2;
  --br-row-rule: #f0f0f4;
  --br-head-bg: #f7f7fa;
  --br-hover: #faf9ff;
  --br-hover-strong: #f1efff;
  --br-accent: #5b4ddb;
  --br-accent-hover: #4a3ec9;
  --br-error: #d32f2f;
  --br-control-h: 40px;
  --br-action-h: 38px;
  --br-radius: 6px;
  --br-card-radius: 8px;
  --br-card-head-h: 46px;
}

.br-shell {
  background: #ffffff;
  min-height: 100%;
  line-height: 1.5;
}

/* One content column; header, tabs, bars and panels all share its edges. */
.br-content {
  width: 100%;
  max-width: calc(var(--br-column) + 48px);
  margin: 0 auto;
  padding: 0 24px;
}

.br-shell__header {
  position: sticky;
  top: 0;
  z-index: 4;
  background: #ffffff;
}
.br-shell__header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
}
.br-shell__title-block {
  display: flex;
  align-items: baseline;
  gap: 8px;
}
.br-shell__title {
  font-size: 17px;
  font-weight: 500;
  line-height: 1.3;
  letter-spacing: -0.005em;
  color: var(--br-text);
}
.br-shell__subtitle {
  font-size: 12.5px;
  font-weight: 300;
  color: var(--br-muted-2);
}
.br-shell__status-pill {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 26px;
  padding: 0 12px;
  border-radius: 13px;
  font-size: 12px;
  font-weight: 400;
  background: #f2f3f7;
  border: 1px solid #e2e4ea;
  color: #4c5163;
}
.br-shell__status-pill--connected {
  background: #e8f6ee;
  border-color: #cbe9d8;
  color: #1e6b42;
}
.br-shell__status-pill--rejected {
  background: #fdecea;
  border-color: #f5cdc8;
  color: #b42318;
}
.br-shell__status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}
.br-shell__status-pill--connected .br-shell__status-dot {
  background: #2f9e5e;
}

/* Tab strip sticky under the header; its own type/rule live in overrides.css. */
.br-content > div {
  overflow: visible !important;
}
.br-content > div > [class*="ContainedTabs_module_navigation_tabs_container"] {
  position: sticky;
  top: 56px;
  z-index: 3;
  background: #ffffff;
}

.br-shell__banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0 0 22px;
  padding: 0 16px;
  height: 48px;
  background: #fffaf0;
  border: 1px solid #f3dfb8;
  border-radius: var(--br-card-radius);
  font-size: 13px;
  color: #6b5a2e;
}
.br-shell__banner-cta {
  flex: 0 0 auto;
  font: inherit;
  font-size: 12.5px;
  font-weight: 400;
  color: #ffffff;
  background: var(--br-accent);
  border: 1px solid var(--br-accent);
  border-radius: var(--br-radius);
  height: 30px;
  padding: 0 16px;
  cursor: pointer;
}
.br-shell__banner-cta:hover {
  background: var(--br-accent-hover);
  border-color: var(--br-accent-hover);
}

.br-skeleton {
  padding: 24px 0;
}
.br-skeleton__row {
  height: 16px;
  border-radius: 4px;
  margin-bottom: 16px;
  background: linear-gradient(90deg, #f5f5f8 25%, #eceef2 37%, #f5f5f8 63%);
  background-size: 400% 100%;
  animation: br-skeleton-pulse 1.4s ease infinite;
}
.br-skeleton__row:nth-child(2) {
  width: 80%;
}
.br-skeleton__row:nth-child(3) {
  width: 60%;
}
@keyframes br-skeleton-pulse {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}

.br-shell__center-message {
  padding: 40px 0;
  text-align: center;
}

/* AuthScreen: shown in place of the whole shell, so it centers on its own instead of
   sitting inside .br-content's column. */
.br-auth {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 24px;
}
.br-auth__card {
  box-sizing: border-box;
  width: 100%;
  max-width: 360px;
  padding: 28px;
  border: 1px solid var(--br-card-border);
  border-radius: var(--br-card-radius);
  background: #ffffff;
  box-shadow: 0 1px 3px 0 rgba(15, 20, 35, 0.08);
}
.br-auth__title {
  margin: 0 0 4px;
  font-size: 17px;
  font-weight: 500;
  line-height: 1.3;
  color: var(--br-text);
}
.br-auth__subtitle {
  margin: 0 0 22px;
  font-size: 12.5px;
  font-weight: 300;
  color: var(--br-muted-2);
}
.br-auth__label {
  display: block;
  margin-bottom: 6px;
  font-size: 11.5px;
  color: var(--br-muted);
}
.br-auth__input {
  box-sizing: border-box;
  width: 100%;
  height: var(--br-control-h);
  padding: 0 12px;
  border: 1px solid var(--br-control-border);
  border-radius: var(--br-radius);
  font: inherit;
  font-size: 13px;
  color: var(--br-text);
  background: #ffffff;
}
.br-auth__input:focus {
  outline: none;
  border-color: var(--br-accent);
}
.br-auth__error {
  margin: 10px 0 0;
  font-size: 12px;
  color: #c0392b;
}
.br-auth__submit {
  width: 100%;
  height: var(--br-action-h);
  margin-top: 18px;
  border: 0;
  border-radius: var(--br-radius);
  background: var(--br-accent);
  color: #ffffff;
  font: inherit;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}
.br-auth__submit:hover {
  background: var(--br-accent-hover);
}
.br-auth__submit:disabled {
  opacity: 0.6;
  cursor: default;
}

/* OutsideBloomreach: full-page setup card shown when the widget is opened outside Bloomreach. */
.br-outside {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 32px 16px 16px;
  box-sizing: border-box;
  background:
    radial-gradient(circle at 15% 0%, var(--br-hover-strong) 0, transparent 45%),
    radial-gradient(circle at 100% 100%, #eef1ff 0, transparent 40%),
    var(--br-head-bg);
}
.br-outside__card {
  box-sizing: border-box;
  width: 100%;
  max-width: 520px;
  padding: 28px 28px 24px;
  border: 1px solid var(--br-card-border);
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(15, 20, 35, 0.04), 0 12px 32px -12px rgba(40, 30, 120, 0.18);
}
.br-outside__header {
  display: flex;
  align-items: center;
  gap: 12px;
}
.br-outside__logo-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: var(--br-hover-strong);
}
.br-outside__logo {
  width: 26px;
  height: 26px;
}
.br-outside__title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.25;
  color: var(--br-text);
}
.br-outside__badge {
  display: inline-block;
  margin-top: 3px;
  padding: 1px 8px;
  border-radius: 999px;
  background: var(--br-head-bg);
  border: 1px solid var(--br-card-border);
  font-size: 11px;
  color: var(--br-muted);
}
.br-outside__notice {
  display: flex;
  gap: 10px;
  margin: 20px 0 22px;
  padding: 12px 14px;
  border: 1px solid #d9d4ff;
  border-radius: 10px;
  background: var(--br-hover);
  font-size: 13px;
  line-height: 1.5;
  color: var(--br-body);
}
.br-outside__notice svg {
  flex: none;
  margin-top: 1px;
  color: var(--br-accent);
}
.br-outside__section {
  margin: 0 0 12px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--br-muted);
}
.br-outside__steps {
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 13px;
  line-height: 1.55;
  color: var(--br-body);
}
.br-outside__steps li {
  display: flex;
  gap: 12px;
}
.br-outside__steps li > div {
  flex: 1 1;
  min-width: 0;
  padding-top: 2px;
}
.br-outside__steps li + li {
  margin-top: 14px;
}
.br-outside__steps strong {
  font-weight: 600;
  color: var(--br-text);
}
.br-outside__step-no {
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--br-accent);
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
}
.br-outside__url {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  padding: 6px 6px 6px 12px;
  border: 1px solid var(--br-card-border);
  border-radius: 8px;
  background: var(--br-head-bg);
}
.br-outside__url code {
  flex: 1 1;
  min-width: 0;
  overflow-wrap: anywhere;
  font-size: 12px;
  color: var(--br-text);
}
.br-outside__url-segment {
  white-space: nowrap;
}
.br-outside__copy {
  flex: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 30px;
  padding: 0 12px;
  border: 1px solid var(--br-control-border);
  border-radius: 6px;
  background: #ffffff;
  font: inherit;
  font-size: 12px;
  font-weight: 500;
  color: var(--br-text);
  cursor: pointer;
  transition: border-color 0.15s, color 0.15s, background 0.15s;
}
.br-outside__copy:hover {
  border-color: var(--br-accent);
  color: var(--br-accent);
}
.br-outside__copy--done,
.br-outside__copy--done:hover {
  border-color: #1f9d55;
  background: #ecf8f1;
  color: #1f9d55;
}
.br-outside__guide {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 40px;
  margin-top: 24px;
  border-radius: 8px;
  background: var(--br-accent);
  color: #ffffff;
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
  transition: background 0.15s;
}
.br-outside__guide:hover {
  background: var(--br-accent-hover);
}
.br-outside__copy:focus-visible,
.br-outside__guide:focus-visible {
  outline: 2px solid var(--br-accent);
  outline-offset: 2px;
}
.br-outside__footer {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 20px;
  font-size: 12px;
  color: var(--br-faint);
}

.br-shell__footer-logo {
  height: 18px;
  width: auto;
  mix-blend-mode: multiply;
}

.br-shell__error-detail {
  padding: 0 0 16px;
}
.br-shell__error-detail button {
  font: inherit;
  font-size: 12px;
  color: var(--br-accent);
  background: none;
  border: 0;
  padding: 0;
  cursor: pointer;
}

/* Message tab — the column's 22px rhythm between context bar, hint, panes and footer. */
.br-message {
  display: flex;
  flex-direction: column;
  gap: 22px;
  padding: 0 0 24px;
}
/* tabindex="-1": script focus lands here when the button that held it goes away (Message keepFocus). It is not a control, so
   no ring; the controls inside keep theirs. */
.br-message:focus {
  outline: none;
}
/* headerComponent slot; we pass none, so it would otherwise add a 10px band + a gap. */
.br-library > div[style*="padding-top: 10px"]:empty {
  display: none;
}
/* .br-composer holds the shared component (in .br-library) and our panel (Message/index.js). Neither draws a box, so
   their parts stay flex items of .br-message. overrides.css reads \`:is(.br-composer, .br-library) > ...\` where it once
   read \`.br-message > ...\`: the panel's parts are children of the first, the component's of the second.
   A panel hides .br-library. The component keeps its state, so its list comes back as the marketer left it. */
.br-composer,
.br-library {
  display: contents;
}
/* An author display beats the browser's [hidden] rule. */
.br-library[hidden] {
  display: none;
}

.br-context-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  height: 48px;
  padding: 0 16px;
  background: var(--br-head-bg);
  border: 1px solid var(--br-card-border);
  border-radius: var(--br-card-radius);
}
.br-context-bar__left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.br-context-bar__name {
  font-size: 13.5px;
  font-weight: 500;
  color: var(--br-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* The template dropdown in place of the name (Message/TemplateSwitcher.js). A 40px control fits the 48px bar. */
.br-template-switcher {
  flex: 0 1 300px;
  min-width: 0;
}
/* The bar already says what the control is; the kit would draw a label above it. */
.br-template-switcher .MuiInputLabel-root {
  display: none;
}
.br-context-bar__divider {
  flex: 0 0 auto;
  width: 1px;
  height: 14px;
  background: var(--br-control-border);
}
.br-context-bar__chips {
  display: flex;
  gap: 6px;
}
.br-context-bar__chip {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 9px;
  border: 1px solid #dcdde3;
  border-radius: 11px;
  font-size: 11px;
  letter-spacing: 0.04em;
  color: #5b6070;
  white-space: nowrap;
}
.br-context-bar__right {
  display: flex;
  align-items: center;
  gap: 12px;
}
.br-context-bar__meta {
  font-size: 12px;
  font-weight: 300;
  color: var(--br-muted-2);
  white-space: nowrap;
}
.br-context-bar__restore {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--br-accent);
  white-space: nowrap;
}
.br-context-bar__dismiss {
  font: inherit;
  font-size: 14px;
  line-height: 1;
  color: var(--br-muted);
  background: none;
  border: none;
  cursor: pointer;
  padding: 0 2px;
}
.br-context-bar__dismiss:hover {
  color: var(--br-text);
}

.br-hint {
  margin: 0;
  font-size: 12.5px;
  font-weight: 300;
  line-height: 1.6;
  color: var(--br-muted);
}
.br-hint code {
  font: 400 12px ui-monospace, Menlo, Consolas, monospace;
  color: var(--br-body);
  background: #f2f2f6;
  padding: 1px 5px;
  border-radius: 4px;
}

.br-message > p {
  margin: 0;
  font-size: 12.5px;
  font-weight: 300;
  color: var(--br-muted);
}

/* Expression cheatsheet; sits tight under the hint it expands on, not a block of its own. */
.br-jinja-help {
  margin-top: -10px;
  padding: 0 14px;
  border: 1px solid var(--br-card-border);
  border-radius: var(--br-card-radius);
  font-size: 13px;
  color: var(--br-muted);
}
.br-jinja-help > summary {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  font-size: 12.5px;
  color: var(--br-accent);
  cursor: pointer;
  list-style: none;
  -webkit-user-select: none;
          user-select: none;
}
.br-jinja-help > summary::-webkit-details-marker {
  display: none;
}
.br-jinja-help > summary::before {
  content: "\\203A";
  font-size: 14px;
  line-height: 1;
  color: var(--br-muted-2);
  transition: transform 0.12s ease;
}
.br-jinja-help[open] > summary {
  border-bottom: 1px solid var(--br-rule);
}
.br-jinja-help[open] > summary::before {
  transform: rotate(90deg);
}
.br-jinja-help__notes {
  margin: 10px 0 12px;
  padding-left: 18px;
  line-height: 1.7;
}
.br-jinja-help code {
  font: 400 12px ui-monospace, Menlo, Consolas, monospace;
  color: var(--br-body);
  background: #f2f2f6;
  padding: 1px 5px;
  border-radius: 4px;
}

/* A descendant, not a child: the carry notice sits in the status region (.br-live) below. */
.br-message .br-notice {
  margin: 0;
  padding: 9px 12px;
  border-radius: var(--br-radius);
  font-size: 13px;
  font-weight: 400;
  line-height: 1.4;
}
.br-message .br-notice--warn {
  background: #fff7e6;
  border: 1px solid #ffd591;
  color: #6b5a2e;
}
.br-message .br-notice--info {
  background: var(--br-hover);
  border: 1px solid var(--br-hover-strong);
  color: var(--br-body);
}
/* The carry notice's live region has to be in the page before its text, so it stays mounted. Empty, it is out of the flow and
   leaves no gap, like the consent help line below. */
.br-live:empty {
  position: absolute;
}
/* A text button inside a notice. Looks like Send to's Reset (rule below). */
.br-notice__action {
  margin-left: 10px;
}

/* Send to: the message's destination, shown once a template is picked (Message/SendToControl.js). */
.br-sendto {
  display: grid;
  grid-template-columns: auto minmax(0, 440px) auto;
  justify-content: start;
  align-items: center;
  gap: 8px 14px;
  padding: 14px 16px;
  border: 1px solid var(--br-card-border);
  border-radius: var(--br-card-radius);
  background: #ffffff;
}
.br-sendto__label {
  font-size: 13px;
  font-weight: 500;
  color: var(--br-text);
}
.br-sendto__input {
  width: 100%;
  height: 38px;
  padding: 0 12px;
  border: 1px solid var(--br-control-border);
  border-radius: var(--br-radius);
  background: #ffffff;
  font: inherit;
  font-size: 13.5px;
  color: var(--br-text);
}
.br-sendto__input:focus {
  outline: none;
  border-color: var(--br-accent);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--br-accent) 14%, transparent);
}
.br-sendto__input--invalid,
.br-sendto__input--invalid:focus {
  border-color: #c0392b;
  box-shadow: none;
}
/* The kit's Select draws its own label above the control, and its 6px margin stays even when the label is empty. The
   card's label column already names the field. */
.br-sendto .MuiInputLabel-root {
  display: none;
}
.br-sendto__reset,
.br-notice__action {
  padding: 0;
  border: 0;
  background: none;
  font: inherit;
  font-size: 12.5px;
  color: var(--br-accent);
  cursor: pointer;
}
.br-sendto__reset:hover,
.br-notice__action:hover {
  color: var(--br-accent-hover);
  text-decoration: underline;
}
.br-sendto__reset:focus-visible,
.br-notice__action:focus-visible {
  outline: 2px solid var(--br-accent);
  outline-offset: 2px;
}
/* Sits under the input, not under the label. */
.br-sendto__help {
  grid-column: 2 / -1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
/* The consent dropdown has no hint, so with nothing saved either, its help line is empty. Out of the flow it leaves no
   empty row and no row gap under the control. It stays in the DOM: the live "saved" line has to exist before its text. */
.br-sendto__help:not(:has(> :not(:empty))) {
  position: absolute;
}
.br-sendto__hint,
.br-sendto__error,
.br-sendto__warn {
  margin: 0;
  font-size: 12.5px;
  line-height: 1.5;
}
.br-sendto__hint {
  font-weight: 300;
  color: var(--br-muted);
}
.br-sendto__hint code {
  font: 400 12px ui-monospace, Menlo, Consolas, monospace;
  color: var(--br-body);
  background: #f2f2f6;
  padding: 1px 5px;
  border-radius: 4px;
}
.br-sendto__error {
  color: #c0392b;
}
.br-sendto__warn {
  padding: 8px 12px;
  border: 1px solid #ffd591;
  border-radius: var(--br-radius);
  background: #fff7e6;
  color: #6b5a2e;
}
@media (max-width: 560px) {
  .br-sendto {
    grid-template-columns: minmax(0, 1fr) auto;
  }
  .br-sendto__label,
  .br-sendto__help {
    grid-column: 1 / -1;
  }
}

/* Footer bar contents (the bar itself is the component's footer, styled in overrides.css). */
.br-footer-left {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.br-save-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  color: var(--br-body);
}
.br-save-status--saved {
  color: #1e6b42;
}
.br-save-status--saved::before {
  content: "\\2713";
}
.br-footer-caption {
  font-size: 11.5px;
  font-weight: 300;
  color: var(--br-faint);
}

/* Account Settings tab */
.br-account {
  display: flex;
  flex-direction: column;
  gap: 22px;
  padding: 24px 0;
}
.br-section-header__title {
  font-size: 15px;
  font-weight: 500;
  line-height: 1.4;
  color: var(--br-text);
}
.br-section-header__subtitle {
  font-size: 12.5px;
  font-weight: 300;
  line-height: 1.6;
  color: var(--br-muted);
  margin-top: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,oFAAoF;AACpF;EACE,2CAA2C;EAC3C,eAAe;EACf,cAAc;AAChB;;AAEA,uFAAuF;AACvF;EACE,yFAAyF;EACzF,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,+EAA+E;AAC/E;EACE,sBAAsB;AACxB;;AAEA;;+FAE+F;AAC/F;EACE,iCAAiC;EACjC,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA,+DAA+D;AAC/D;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,0BAA0B;EAC1B,oBAAoB;EACpB,0BAA0B;EAC1B,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,2EAA2E;AAC3E;EACE,WAAW;EACX,wCAAwC;EACxC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,mBAAmB;AACrB;;AAEA,gFAAgF;AAChF;EACE,4BAA4B;AAC9B;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,oCAAoC;EACpC,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,4BAA4B;EAC5B,kCAAkC;EAClC,+BAA+B;EAC/B,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yEAAyE;EACzE,0BAA0B;EAC1B,+CAA+C;AACjD;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;yCACyC;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,uCAAuC;EACvC,oCAAoC;EACpC,mBAAmB;EACnB,8CAA8C;AAChD;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,2BAA2B;EAC3B,eAAe;EACf,0CAA0C;EAC1C,+BAA+B;EAC/B,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;EACX,0BAA0B;EAC1B,gBAAgB;EAChB,SAAS;EACT,+BAA+B;EAC/B,4BAA4B;EAC5B,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,gGAAgG;AAChG;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB;;;qBAGmB;AACrB;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,uCAAuC;EACvC,mBAAmB;EACnB,mBAAmB;EACnB,uFAAuF;AACzF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,6BAA6B;EAC7B,uCAAuC;EACvC,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,uCAAuC;EACvC,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,0CAA0C;EAC1C,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,6DAA6D;AAC/D;AACA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;AACA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,4BAA4B;AAC9B;AACA;EACE,kCAAkC;AACpC;AACA;;EAEE,mCAAmC;EACnC,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA,wFAAwF;AACxF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;AACA;8CAC8C;AAC9C;EACE,aAAa;AACf;AACA,uFAAuF;AACvF;EACE,aAAa;AACf;AACA;;;8GAG8G;AAC9G;;EAEE,iBAAiB;AACnB;AACA,yDAAyD;AACzD;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,uCAAuC;EACvC,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA,gHAAgH;AAChH;EACE,eAAe;EACf,YAAY;AACd;AACA,mFAAmF;AACnF;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,UAAU;EACV,YAAY;EACZ,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,uDAAuD;EACvD,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,4FAA4F;AAC5F;EACE,iBAAiB;EACjB,eAAe;EACf,uCAAuC;EACvC,oCAAoC;EACpC,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,wBAAwB;EACxB,gCAAgC;AAClC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,uDAAuD;EACvD,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,4FAA4F;AAC5F;EACE,SAAS;EACT,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,wCAAwC;EACxC,qBAAqB;AACvB;AACA;qDACqD;AACrD;EACE,kBAAkB;AACpB;AACA,4EAA4E;AAC5E;EACE,iBAAiB;AACnB;;AAEA,oGAAoG;AACpG;EACE,aAAa;EACb,iDAAiD;EACjD,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,uCAAuC;EACvC,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,0CAA0C;EAC1C,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,2EAA2E;AAC7E;AACA;;EAEE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;iDACiD;AACjD;EACE,aAAa;AACf;AACA;;EAEE,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;AACjB;AACA;;EAEE,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;;EAEE,mCAAmC;EACnC,mBAAmB;AACrB;AACA,+CAA+C;AAC/C;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;yHACyH;AACzH;EACE,kBAAkB;AACpB;AACA;;;EAGE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,uDAAuD;EACvD,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,+BAA+B;EAC/B,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE;IACE,0CAA0C;EAC5C;EACA;;IAEE,mBAAmB;EACrB;AACF;;AAEA,6FAA6F;AAC7F;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB","sourcesContent":["/* Poppins loads via public/index.html's <link>; body covers portaled content too. */\nbody {\n  font-family: Poppins, system-ui, sans-serif;\n  font-size: 13px;\n  color: #1c1c28;\n}\n\n/* gs-integration-component's delete icon 403s from ImageKit; swap for a hosted copy. */\nimg[alt=\"delete\"] {\n  content: url(\"https://gs-upload.gupshup.io/journey-builder/assets/icon/common/cross.svg\");\n  width: 14px;\n  height: 14px;\n  cursor: pointer;\n}\n\n/* Global border-box reset compensates for the Tabs panel's own overflow bug. */\n*, *::before, *::after {\n  box-sizing: border-box;\n}\n\n/* overflow-x:clip (not hidden) + overflow-y:visible — hidden on either axis forces the\n   other to compute as auto per spec, which breaks position:sticky elsewhere (the template\n   preview panel). clip avoids that while still clipping horizontal overflow like hidden did. */\n.bloomreach-widget [class*=\"tabsPanel\"] {\n  box-sizing: border-box !important;\n  max-width: 100% !important;\n  overflow-x: clip;\n  overflow-y: visible;\n}\n\n.bloomreach-widget .nic-tm-header-container,\n.bloomreach-widget .nic-tm-footer-container,\n.bloomreach-widget .nic-sh-main-container,\n.bloomreach-widget .nic-tm-template-search-field {\n  max-width: 100%;\n}\n\n.bloomreach-widget .nic-tm-header-item {\n  min-width: 0;\n}\n\n/* Alignment-pass tokens; overrides.css reads the same names. */\n.bloomreach-widget {\n  --br-column: 1040px;\n  --br-text: #1c1c28;\n  --br-muted: #6b7186;\n  --br-muted-2: #7a8092;\n  --br-faint: #8a90a0;\n  --br-body: #4c5163;\n  --br-control-border: #d7d9e0;\n  --br-card-border: #e6e7ec;\n  --br-rule: #eeeef2;\n  --br-row-rule: #f0f0f4;\n  --br-head-bg: #f7f7fa;\n  --br-hover: #faf9ff;\n  --br-hover-strong: #f1efff;\n  --br-accent: #5b4ddb;\n  --br-accent-hover: #4a3ec9;\n  --br-error: #d32f2f;\n  --br-control-h: 40px;\n  --br-action-h: 38px;\n  --br-radius: 6px;\n  --br-card-radius: 8px;\n  --br-card-head-h: 46px;\n}\n\n.br-shell {\n  background: #ffffff;\n  min-height: 100%;\n  line-height: 1.5;\n}\n\n/* One content column; header, tabs, bars and panels all share its edges. */\n.br-content {\n  width: 100%;\n  max-width: calc(var(--br-column) + 48px);\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n.br-shell__header {\n  position: sticky;\n  top: 0;\n  z-index: 4;\n  background: #ffffff;\n}\n.br-shell__header-inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 56px;\n}\n.br-shell__title-block {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n}\n.br-shell__title {\n  font-size: 17px;\n  font-weight: 500;\n  line-height: 1.3;\n  letter-spacing: -0.005em;\n  color: var(--br-text);\n}\n.br-shell__subtitle {\n  font-size: 12.5px;\n  font-weight: 300;\n  color: var(--br-muted-2);\n}\n.br-shell__status-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  height: 26px;\n  padding: 0 12px;\n  border-radius: 13px;\n  font-size: 12px;\n  font-weight: 400;\n  background: #f2f3f7;\n  border: 1px solid #e2e4ea;\n  color: #4c5163;\n}\n.br-shell__status-pill--connected {\n  background: #e8f6ee;\n  border-color: #cbe9d8;\n  color: #1e6b42;\n}\n.br-shell__status-pill--rejected {\n  background: #fdecea;\n  border-color: #f5cdc8;\n  color: #b42318;\n}\n.br-shell__status-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: currentColor;\n}\n.br-shell__status-pill--connected .br-shell__status-dot {\n  background: #2f9e5e;\n}\n\n/* Tab strip sticky under the header; its own type/rule live in overrides.css. */\n.br-content > div {\n  overflow: visible !important;\n}\n.br-content > div > [class*=\"ContainedTabs_module_navigation_tabs_container\"] {\n  position: sticky;\n  top: 56px;\n  z-index: 3;\n  background: #ffffff;\n}\n\n.br-shell__banner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin: 0 0 22px;\n  padding: 0 16px;\n  height: 48px;\n  background: #fffaf0;\n  border: 1px solid #f3dfb8;\n  border-radius: var(--br-card-radius);\n  font-size: 13px;\n  color: #6b5a2e;\n}\n.br-shell__banner-cta {\n  flex: 0 0 auto;\n  font: inherit;\n  font-size: 12.5px;\n  font-weight: 400;\n  color: #ffffff;\n  background: var(--br-accent);\n  border: 1px solid var(--br-accent);\n  border-radius: var(--br-radius);\n  height: 30px;\n  padding: 0 16px;\n  cursor: pointer;\n}\n.br-shell__banner-cta:hover {\n  background: var(--br-accent-hover);\n  border-color: var(--br-accent-hover);\n}\n\n.br-skeleton {\n  padding: 24px 0;\n}\n.br-skeleton__row {\n  height: 16px;\n  border-radius: 4px;\n  margin-bottom: 16px;\n  background: linear-gradient(90deg, #f5f5f8 25%, #eceef2 37%, #f5f5f8 63%);\n  background-size: 400% 100%;\n  animation: br-skeleton-pulse 1.4s ease infinite;\n}\n.br-skeleton__row:nth-child(2) {\n  width: 80%;\n}\n.br-skeleton__row:nth-child(3) {\n  width: 60%;\n}\n@keyframes br-skeleton-pulse {\n  0% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0 50%;\n  }\n}\n\n.br-shell__center-message {\n  padding: 40px 0;\n  text-align: center;\n}\n\n/* AuthScreen: shown in place of the whole shell, so it centers on its own instead of\n   sitting inside .br-content's column. */\n.br-auth {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  padding: 24px;\n}\n.br-auth__card {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 360px;\n  padding: 28px;\n  border: 1px solid var(--br-card-border);\n  border-radius: var(--br-card-radius);\n  background: #ffffff;\n  box-shadow: 0 1px 3px 0 rgba(15, 20, 35, 0.08);\n}\n.br-auth__title {\n  margin: 0 0 4px;\n  font-size: 17px;\n  font-weight: 500;\n  line-height: 1.3;\n  color: var(--br-text);\n}\n.br-auth__subtitle {\n  margin: 0 0 22px;\n  font-size: 12.5px;\n  font-weight: 300;\n  color: var(--br-muted-2);\n}\n.br-auth__label {\n  display: block;\n  margin-bottom: 6px;\n  font-size: 11.5px;\n  color: var(--br-muted);\n}\n.br-auth__input {\n  box-sizing: border-box;\n  width: 100%;\n  height: var(--br-control-h);\n  padding: 0 12px;\n  border: 1px solid var(--br-control-border);\n  border-radius: var(--br-radius);\n  font: inherit;\n  font-size: 13px;\n  color: var(--br-text);\n  background: #ffffff;\n}\n.br-auth__input:focus {\n  outline: none;\n  border-color: var(--br-accent);\n}\n.br-auth__error {\n  margin: 10px 0 0;\n  font-size: 12px;\n  color: #c0392b;\n}\n.br-auth__submit {\n  width: 100%;\n  height: var(--br-action-h);\n  margin-top: 18px;\n  border: 0;\n  border-radius: var(--br-radius);\n  background: var(--br-accent);\n  color: #ffffff;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n}\n.br-auth__submit:hover {\n  background: var(--br-accent-hover);\n}\n.br-auth__submit:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n/* OutsideBloomreach: full-page setup card shown when the widget is opened outside Bloomreach. */\n.br-outside {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  padding: 32px 16px 16px;\n  box-sizing: border-box;\n  background:\n    radial-gradient(circle at 15% 0%, var(--br-hover-strong) 0, transparent 45%),\n    radial-gradient(circle at 100% 100%, #eef1ff 0, transparent 40%),\n    var(--br-head-bg);\n}\n.br-outside__card {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 520px;\n  padding: 28px 28px 24px;\n  border: 1px solid var(--br-card-border);\n  border-radius: 14px;\n  background: #ffffff;\n  box-shadow: 0 1px 2px rgba(15, 20, 35, 0.04), 0 12px 32px -12px rgba(40, 30, 120, 0.18);\n}\n.br-outside__header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.br-outside__logo-wrap {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  background: var(--br-hover-strong);\n}\n.br-outside__logo {\n  width: 26px;\n  height: 26px;\n}\n.br-outside__title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 1.25;\n  color: var(--br-text);\n}\n.br-outside__badge {\n  display: inline-block;\n  margin-top: 3px;\n  padding: 1px 8px;\n  border-radius: 999px;\n  background: var(--br-head-bg);\n  border: 1px solid var(--br-card-border);\n  font-size: 11px;\n  color: var(--br-muted);\n}\n.br-outside__notice {\n  display: flex;\n  gap: 10px;\n  margin: 20px 0 22px;\n  padding: 12px 14px;\n  border: 1px solid #d9d4ff;\n  border-radius: 10px;\n  background: var(--br-hover);\n  font-size: 13px;\n  line-height: 1.5;\n  color: var(--br-body);\n}\n.br-outside__notice svg {\n  flex: none;\n  margin-top: 1px;\n  color: var(--br-accent);\n}\n.br-outside__section {\n  margin: 0 0 12px;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--br-muted);\n}\n.br-outside__steps {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  font-size: 13px;\n  line-height: 1.55;\n  color: var(--br-body);\n}\n.br-outside__steps li {\n  display: flex;\n  gap: 12px;\n}\n.br-outside__steps li > div {\n  flex: 1;\n  min-width: 0;\n  padding-top: 2px;\n}\n.br-outside__steps li + li {\n  margin-top: 14px;\n}\n.br-outside__steps strong {\n  font-weight: 600;\n  color: var(--br-text);\n}\n.br-outside__step-no {\n  flex: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: var(--br-accent);\n  color: #ffffff;\n  font-size: 12px;\n  font-weight: 600;\n}\n.br-outside__url {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 8px;\n  padding: 6px 6px 6px 12px;\n  border: 1px solid var(--br-card-border);\n  border-radius: 8px;\n  background: var(--br-head-bg);\n}\n.br-outside__url code {\n  flex: 1;\n  min-width: 0;\n  overflow-wrap: anywhere;\n  font-size: 12px;\n  color: var(--br-text);\n}\n.br-outside__url-segment {\n  white-space: nowrap;\n}\n.br-outside__copy {\n  flex: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 30px;\n  padding: 0 12px;\n  border: 1px solid var(--br-control-border);\n  border-radius: 6px;\n  background: #ffffff;\n  font: inherit;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--br-text);\n  cursor: pointer;\n  transition: border-color 0.15s, color 0.15s, background 0.15s;\n}\n.br-outside__copy:hover {\n  border-color: var(--br-accent);\n  color: var(--br-accent);\n}\n.br-outside__copy--done,\n.br-outside__copy--done:hover {\n  border-color: #1f9d55;\n  background: #ecf8f1;\n  color: #1f9d55;\n}\n.br-outside__guide {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 40px;\n  margin-top: 24px;\n  border-radius: 8px;\n  background: var(--br-accent);\n  color: #ffffff;\n  font-size: 13px;\n  font-weight: 500;\n  text-decoration: none;\n  transition: background 0.15s;\n}\n.br-outside__guide:hover {\n  background: var(--br-accent-hover);\n}\n.br-outside__copy:focus-visible,\n.br-outside__guide:focus-visible {\n  outline: 2px solid var(--br-accent);\n  outline-offset: 2px;\n}\n.br-outside__footer {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 20px;\n  font-size: 12px;\n  color: var(--br-faint);\n}\n\n.br-shell__footer-logo {\n  height: 18px;\n  width: auto;\n  mix-blend-mode: multiply;\n}\n\n.br-shell__error-detail {\n  padding: 0 0 16px;\n}\n.br-shell__error-detail button {\n  font: inherit;\n  font-size: 12px;\n  color: var(--br-accent);\n  background: none;\n  border: 0;\n  padding: 0;\n  cursor: pointer;\n}\n\n/* Message tab — the column's 22px rhythm between context bar, hint, panes and footer. */\n.br-message {\n  display: flex;\n  flex-direction: column;\n  gap: 22px;\n  padding: 0 0 24px;\n}\n/* tabindex=\"-1\": script focus lands here when the button that held it goes away (Message keepFocus). It is not a control, so\n   no ring; the controls inside keep theirs. */\n.br-message:focus {\n  outline: none;\n}\n/* headerComponent slot; we pass none, so it would otherwise add a 10px band + a gap. */\n.br-library > div[style*=\"padding-top: 10px\"]:empty {\n  display: none;\n}\n/* .br-composer holds the shared component (in .br-library) and our panel (Message/index.js). Neither draws a box, so\n   their parts stay flex items of .br-message. overrides.css reads `:is(.br-composer, .br-library) > ...` where it once\n   read `.br-message > ...`: the panel's parts are children of the first, the component's of the second.\n   A panel hides .br-library. The component keeps its state, so its list comes back as the marketer left it. */\n.br-composer,\n.br-library {\n  display: contents;\n}\n/* An author display beats the browser's [hidden] rule. */\n.br-library[hidden] {\n  display: none;\n}\n\n.br-context-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  height: 48px;\n  padding: 0 16px;\n  background: var(--br-head-bg);\n  border: 1px solid var(--br-card-border);\n  border-radius: var(--br-card-radius);\n}\n.br-context-bar__left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n.br-context-bar__name {\n  font-size: 13.5px;\n  font-weight: 500;\n  color: var(--br-text);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n/* The template dropdown in place of the name (Message/TemplateSwitcher.js). A 40px control fits the 48px bar. */\n.br-template-switcher {\n  flex: 0 1 300px;\n  min-width: 0;\n}\n/* The bar already says what the control is; the kit would draw a label above it. */\n.br-template-switcher .MuiInputLabel-root {\n  display: none;\n}\n.br-context-bar__divider {\n  flex: 0 0 auto;\n  width: 1px;\n  height: 14px;\n  background: var(--br-control-border);\n}\n.br-context-bar__chips {\n  display: flex;\n  gap: 6px;\n}\n.br-context-bar__chip {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 9px;\n  border: 1px solid #dcdde3;\n  border-radius: 11px;\n  font-size: 11px;\n  letter-spacing: 0.04em;\n  color: #5b6070;\n  white-space: nowrap;\n}\n.br-context-bar__right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.br-context-bar__meta {\n  font-size: 12px;\n  font-weight: 300;\n  color: var(--br-muted-2);\n  white-space: nowrap;\n}\n.br-context-bar__restore {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: var(--br-accent);\n  white-space: nowrap;\n}\n.br-context-bar__dismiss {\n  font: inherit;\n  font-size: 14px;\n  line-height: 1;\n  color: var(--br-muted);\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0 2px;\n}\n.br-context-bar__dismiss:hover {\n  color: var(--br-text);\n}\n\n.br-hint {\n  margin: 0;\n  font-size: 12.5px;\n  font-weight: 300;\n  line-height: 1.6;\n  color: var(--br-muted);\n}\n.br-hint code {\n  font: 400 12px ui-monospace, Menlo, Consolas, monospace;\n  color: var(--br-body);\n  background: #f2f2f6;\n  padding: 1px 5px;\n  border-radius: 4px;\n}\n\n.br-message > p {\n  margin: 0;\n  font-size: 12.5px;\n  font-weight: 300;\n  color: var(--br-muted);\n}\n\n/* Expression cheatsheet; sits tight under the hint it expands on, not a block of its own. */\n.br-jinja-help {\n  margin-top: -10px;\n  padding: 0 14px;\n  border: 1px solid var(--br-card-border);\n  border-radius: var(--br-card-radius);\n  font-size: 13px;\n  color: var(--br-muted);\n}\n.br-jinja-help > summary {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  height: 34px;\n  font-size: 12.5px;\n  color: var(--br-accent);\n  cursor: pointer;\n  list-style: none;\n  user-select: none;\n}\n.br-jinja-help > summary::-webkit-details-marker {\n  display: none;\n}\n.br-jinja-help > summary::before {\n  content: \"\\203A\";\n  font-size: 14px;\n  line-height: 1;\n  color: var(--br-muted-2);\n  transition: transform 0.12s ease;\n}\n.br-jinja-help[open] > summary {\n  border-bottom: 1px solid var(--br-rule);\n}\n.br-jinja-help[open] > summary::before {\n  transform: rotate(90deg);\n}\n.br-jinja-help__notes {\n  margin: 10px 0 12px;\n  padding-left: 18px;\n  line-height: 1.7;\n}\n.br-jinja-help code {\n  font: 400 12px ui-monospace, Menlo, Consolas, monospace;\n  color: var(--br-body);\n  background: #f2f2f6;\n  padding: 1px 5px;\n  border-radius: 4px;\n}\n\n/* A descendant, not a child: the carry notice sits in the status region (.br-live) below. */\n.br-message .br-notice {\n  margin: 0;\n  padding: 9px 12px;\n  border-radius: var(--br-radius);\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 1.4;\n}\n.br-message .br-notice--warn {\n  background: #fff7e6;\n  border: 1px solid #ffd591;\n  color: #6b5a2e;\n}\n.br-message .br-notice--info {\n  background: var(--br-hover);\n  border: 1px solid var(--br-hover-strong);\n  color: var(--br-body);\n}\n/* The carry notice's live region has to be in the page before its text, so it stays mounted. Empty, it is out of the flow and\n   leaves no gap, like the consent help line below. */\n.br-live:empty {\n  position: absolute;\n}\n/* A text button inside a notice. Looks like Send to's Reset (rule below). */\n.br-notice__action {\n  margin-left: 10px;\n}\n\n/* Send to: the message's destination, shown once a template is picked (Message/SendToControl.js). */\n.br-sendto {\n  display: grid;\n  grid-template-columns: auto minmax(0, 440px) auto;\n  justify-content: start;\n  align-items: center;\n  gap: 8px 14px;\n  padding: 14px 16px;\n  border: 1px solid var(--br-card-border);\n  border-radius: var(--br-card-radius);\n  background: #ffffff;\n}\n.br-sendto__label {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--br-text);\n}\n.br-sendto__input {\n  width: 100%;\n  height: 38px;\n  padding: 0 12px;\n  border: 1px solid var(--br-control-border);\n  border-radius: var(--br-radius);\n  background: #ffffff;\n  font: inherit;\n  font-size: 13.5px;\n  color: var(--br-text);\n}\n.br-sendto__input:focus {\n  outline: none;\n  border-color: var(--br-accent);\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--br-accent) 14%, transparent);\n}\n.br-sendto__input--invalid,\n.br-sendto__input--invalid:focus {\n  border-color: #c0392b;\n  box-shadow: none;\n}\n/* The kit's Select draws its own label above the control, and its 6px margin stays even when the label is empty. The\n   card's label column already names the field. */\n.br-sendto .MuiInputLabel-root {\n  display: none;\n}\n.br-sendto__reset,\n.br-notice__action {\n  padding: 0;\n  border: 0;\n  background: none;\n  font: inherit;\n  font-size: 12.5px;\n  color: var(--br-accent);\n  cursor: pointer;\n}\n.br-sendto__reset:hover,\n.br-notice__action:hover {\n  color: var(--br-accent-hover);\n  text-decoration: underline;\n}\n.br-sendto__reset:focus-visible,\n.br-notice__action:focus-visible {\n  outline: 2px solid var(--br-accent);\n  outline-offset: 2px;\n}\n/* Sits under the input, not under the label. */\n.br-sendto__help {\n  grid-column: 2 / -1;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n/* The consent dropdown has no hint, so with nothing saved either, its help line is empty. Out of the flow it leaves no\n   empty row and no row gap under the control. It stays in the DOM: the live \"saved\" line has to exist before its text. */\n.br-sendto__help:not(:has(> :not(:empty))) {\n  position: absolute;\n}\n.br-sendto__hint,\n.br-sendto__error,\n.br-sendto__warn {\n  margin: 0;\n  font-size: 12.5px;\n  line-height: 1.5;\n}\n.br-sendto__hint {\n  font-weight: 300;\n  color: var(--br-muted);\n}\n.br-sendto__hint code {\n  font: 400 12px ui-monospace, Menlo, Consolas, monospace;\n  color: var(--br-body);\n  background: #f2f2f6;\n  padding: 1px 5px;\n  border-radius: 4px;\n}\n.br-sendto__error {\n  color: #c0392b;\n}\n.br-sendto__warn {\n  padding: 8px 12px;\n  border: 1px solid #ffd591;\n  border-radius: var(--br-radius);\n  background: #fff7e6;\n  color: #6b5a2e;\n}\n@media (max-width: 560px) {\n  .br-sendto {\n    grid-template-columns: minmax(0, 1fr) auto;\n  }\n  .br-sendto__label,\n  .br-sendto__help {\n    grid-column: 1 / -1;\n  }\n}\n\n/* Footer bar contents (the bar itself is the component's footer, styled in overrides.css). */\n.br-footer-left {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.br-save-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12.5px;\n  color: var(--br-body);\n}\n.br-save-status--saved {\n  color: #1e6b42;\n}\n.br-save-status--saved::before {\n  content: \"\\2713\";\n}\n.br-footer-caption {\n  font-size: 11.5px;\n  font-weight: 300;\n  color: var(--br-faint);\n}\n\n/* Account Settings tab */\n.br-account {\n  display: flex;\n  flex-direction: column;\n  gap: 22px;\n  padding: 24px 0;\n}\n.br-section-header__title {\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 1.4;\n  color: var(--br-text);\n}\n.br-section-header__subtitle {\n  font-size: 12.5px;\n  font-weight: 300;\n  line-height: 1.6;\n  color: var(--br-muted);\n  margin-top: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
